module.exports = __webpack_public_path__ + "d126cc601c064b28f5452bd40138acbc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-32.png
// module id = 2611
// module chunks = 0